module.exports = __webpack_public_path__ + "img/course72_curriculum.1dfc8a9e.jpg";